// extracted by mini-css-extract-plugin
export default {"selectedlang":"LanguageDropDown_selectedlang__BrZBp","languageoptions":"LanguageDropDown_languageoptions__qbKzK"};